import { DatePipe, UpperCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { IsFutureDatePipe } from '@zero/shared/ui-pipes';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { BezugsrechtBackLinkComponent } from '../back-link/bezugsrecht-back-link.component';
import { BezugsrechtBase } from '../bezugsrecht.base';

@Component({
  imports: [TranslocoPipe, RouterLink, BezugsrechtBackLinkComponent, IsFutureDatePipe, ButtonComponent, UpperCasePipe, DatePipe],
  templateUrl: './bezugsrecht-home.component.html',
})
export class BezugsrechtHomeComponent extends BezugsrechtBase {
  public override back = (): void => {
    this.router.navigateByUrl(this.commonRoutes.postlogin.member_home);
  };
}
